import {useTranslation} from 'react-i18next'

import mfaLogo from 'images/wallet/google-authenticator.png'

import {Container, Text, TextBold, LogoWrapper, MfaLogo} from './WalletMfaDownloadInfoBox.styles'

const WalletMfaDownloadInfoBox = () => {
  const {t} = useTranslation()
  return (
    <Container>
      <Text>
        <TextBold>{t('wallet.mfaInfo.downloadInfo.textBold')}</TextBold>{' '}
        {t('wallet.mfaInfo.downloadInfo.text')}
      </Text>
      <LogoWrapper>
        <MfaLogo src={mfaLogo} />
      </LogoWrapper>
    </Container>
  )
}

export default WalletMfaDownloadInfoBox
